import React, { useEffect, useState } from "react";
import { postAPICall, putAPICall, DeleteAPICall, 
   showErrorToast, showSuccessToast } from "../Api/Api";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { IoAddOutline } from "react-icons/io5";
import { MdModeEdit } from "react-icons/md";
import { MdDelete } from "react-icons/md";
import { Dropdown } from "primereact/dropdown";
import "./AdminStyle.css";
import GlobalPopup from "../GlobalComponents/GlobalPopup";
export default function Master(props) {
  const [user, setUser] = useState([]);
  const [userTypeData, setUserTypeData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);
  const [editDialogVisible, setEditDialogVisible] = useState(false);
  const [editedUser, setEditedUser] = useState(null);
  const [showDialog, setShowDialog] = useState(false);
  const [newUserData, setNewUserData] = useState({});
  const [usernameValid, setUsernameValid] = useState(true);
  const [passwordValid, setPasswordValid] = useState(true);
  const [mailAddressValid, setMailAddressValid] = useState(true);
  const [mobileNumberValid, setMobileNumberValid] = useState(true);
  const [userTypeIdValid, setUserTypeIdValid] = useState(true);
  const [SelectedUserTypevalue, setSelectedUserTypevalue] = useState([]);
  const [SelectedUserTypeEditvalue, setSelectedUserTypeEditvalue] = useState(
    []
  );
  const [selectedRowUser, setSelectedRowUser] = useState([]);
  useEffect(() => {
    fetchDataUserData();
    fetchDataUserType();
  }, [props]);

  const fetchDataUserData = async () => {
    try {
      const requestBody = {};
      const response = await postAPICall(
        "api/PortalLogin/GetUserCreation",
        requestBody
      );
      setUser(response?.data || []);
    } catch (error) {
      showErrorToast("Error fetching user data:" );
    }
  };

  const fetchDataUserType = async () => {
    try {
      const requestBody = {};
      const response = await postAPICall(
        "api/PortalLogin/GetUserType",
        requestBody
      );
      setUserTypeData(response?.data || []);
    } catch (error) {
      showErrorToast("Error fetching user type data:");
    }
  };

  const HandeleRowSelect = (e) => {
    const clickedValue = e.value;
    setSelectedRowUser(e.value);
    if (!isNaN(clickedValue)) {
      return;
    }
    let x = props.onClickCheck(clickedValue);
  };

  const handleEdit = (userTypeData, RowData) => {
    setSelectedUser(RowData);
    setEditDialogVisible(true);
    const selectedUserType = userTypeData.find(
      (data) => data.UserType === RowData.UserType
    );
    setSelectedUserTypevalue(
      selectedUserType ? selectedUserType.UserTypeId : null
    );
    setEditedUser({ ...RowData });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedUser((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmitEdit = async () => {
    const requestBody = {
      UserID: editedUser.UserID,
      userName: editedUser.Username,
      password: editedUser.Password,
      mailAddress: editedUser.MailAddress,
      mobileNumber: editedUser.MobileNumber,
      userTypeID: SelectedUserTypevalue,
    };
    const response = await putAPICall(
      "api/PortalLogin/PutUserCreation",
      requestBody
    );
    fetchDataUserData();
    showSuccessToast( "Users Details Updated...");
    setEditDialogVisible(false);
  };

  const handleDelete = () => {
    setDeleteConfirmation(true);
  };
  const confirmDelete = async () => {
    //setDeleteConfirmation(false);
    const requestBody = {
      userID: selectedUser.UserID,
    };
    const response = await DeleteAPICall(
      "api/PortalLogin/DeleteUserType",
      requestBody
    );
    setDeleteConfirmation(false);
    fetchDataUserData();
    showSuccessToast( "User Deleted Successfully...");
  };

  const actionTemplate = (RowData) => {
    return (
      <div>
        <Button
          id="MasterEditicon"
          icon={<MdModeEdit />}
          title="Edit"
          className="p-button-rounded p-button-primary p-mr-2"
          onClick={() => handleEdit(userTypeData, RowData)}
        />
        <Button
          id="MasterDeleteicon"
          icon={<MdDelete />}
          title="Delete"
          className="p-button-rounded p-button-primary"
          onClick={() => {
            setSelectedUser(RowData);
            handleDelete();
          }}
        />
      </div>
    );
  };

  const openNew = () => {
    setShowDialog(true);
  };

  const handleNewInputChange = (e, field) => {
    setNewUserData((prevData) => ({
      ...prevData,
      [field]: e.target.value,
    }));
  };

  const handleNewSubmit = async () => {
    try {
      if (
        !newUserData.Username ||
        !newUserData.Password ||
        !newUserData.UserTypeId
      ) {
        showErrorToast( "Please fill in all fields...");
        setUsernameValid(!!newUserData.Username);
        setPasswordValid(!!newUserData.Password);
        setMailAddressValid(!!newUserData.MailAddress);
        setMobileNumberValid(!!newUserData.MobileNumber);
        setUserTypeIdValid(!!newUserData.UserTypeId);
        return;
      }
      const requestBody = {
        userName: newUserData.Username || null,
        password: newUserData.Password || null,
        mailAddress: newUserData.MailAddress || null,
        mobileNumber: newUserData.MobileNumber || null,
        userTypeID: newUserData.UserTypeId || null,
      };
      const response = await postAPICall(
        "api/PortalLogin/PostUserCreation",
        requestBody
      );
      showSuccessToast("User added successfully...");
      fetchDataUserData();
      setShowDialog(false);
      setNewUserData({});
    } catch (error) {
      console.error("Error adding user:", error);
      showErrorToast( "Unable to Create user");
    }
  };

  const footerButtonsNewuser = (
    <div>
      <Button
        id="BtnSave"
        label="Save"
        icon="pi pi-check"
        onClick={handleNewSubmit}
        autoFocus
      />
      <Button
        id="BtnCancel"
        label="Cancel"
        icon="pi pi-times"
        onClick={() => setShowDialog(false)}
        className="p-button-text"
      />
    </div>
  );
  // Filter channels based on search query
  const filteredUser = user?.filter(
    (channel) =>
      // channel.Password.toLowerCase().includes(searchQuery.toLowerCase()) ||
      channel.Username.toLowerCase().includes(searchQuery.toLowerCase()) ||
      channel.MailAddress.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const footerButtons = (
    <>
      <div>
        <Button
          style={{ borderRadius: "5px", padding: "15px" }}
          label="Submit"
          icon="pi pi-check"
          onClick={handleSubmitEdit}
          autoFocus
        />
        <Button
          style={{
            borderRadius: "5px",
            padding: "15px",
            backgroundColor: "lightslategray",
            color: "white",
          }}
          label="Cancel"
          icon="pi pi-times"
          onClick={() => setEditDialogVisible(false)}
          className="p-button-text"
        />
      </div>
    </>
  );
  const EditUsers = (
    <div className="p-fluid" style={{ padding: "10px" }}>
      <div className="p-field">
        <label htmlFor="username">Username</label>
        <InputText
          id="username"
          name="Username"
          value={editedUser?.Username}
          onChange={handleInputChange}
          onBlur={() => setUsernameValid(!!editedUser?.Username)}
          className={!usernameValid ? "p-invalid" : ""}
        />
      </div>
      <div className="p-field">
        <label htmlFor="password">Password</label>
        <InputText
          id="password"
          name="Password"
          value={editedUser?.Password}
          onChange={handleInputChange}
          onBlur={() => setPasswordValid(!!editedUser?.Password)}
          className={!passwordValid ? "p-invalid" : ""}
        />
      </div>
      <div className="p-field">
        <label htmlFor="mail">Mail Address</label>
        <InputText
          id="mail"
          name="MailAddress"
          value={editedUser?.MailAddress}
          onChange={handleInputChange}
          onBlur={() => setMailAddressValid(!!editedUser?.MailAddress)}
          className={!mailAddressValid ? "p-invalid" : ""}
        />
      </div>
      <div className="p-field">
        <label htmlFor="mail">MobileNumber</label>
        <InputText
          id="MobileNumber"
          name="MobileNumber"
          value={editedUser?.MobileNumber}
          onChange={handleInputChange}
          onBlur={() => setMobileNumberValid(!!editedUser?.MobileNumber)}
          className={!mobileNumberValid ? "p-invalid" : ""}
        />
      </div>
      <div className="p-field">
        <label htmlFor="mail">UserTypeId</label>
        <Dropdown
          id="UserTypeId"
          placeholder="Select a UserType"
          value={SelectedUserTypevalue}
          onChange={(e) => {
            setSelectedUserTypeEditvalue(
              userTypeData.find((type) => type.UserTypeId === e.value)
            );
            setSelectedUserTypevalue(e.value);
          }}
          options={userTypeData.map((type) => ({
            label: type.UserType,
            value: type.UserTypeId,
          }))}
        />
      </div>
    </div>
  );
  const NewUser = (
    <>
      <div className="p-fluid" style={{ padding: "10px" }}>
        <div className="p-field">
          <label htmlFor="newUsername">Username</label>
          <InputText
            id="newUsername"
            value={newUserData.Username || ""}
            onChange={(e) => handleNewInputChange(e, "Username")}
            onBlur={() => setUsernameValid(!!newUserData.Username)}
            className={!usernameValid ? "p-invalid" : ""}
          />
        </div>
        <div className="p-field">
          <label htmlFor="newPassword">Password</label>
          <InputText
            id="newPassword"
            value={newUserData.Password || ""}
            onChange={(e) => handleNewInputChange(e, "Password")}
            onBlur={() => setPasswordValid(!!newUserData.Password)}
            className={!passwordValid ? "p-invalid" : ""}
          />
        </div>
        <div className="p-field">
          <label htmlFor="newMail">Mail Address</label>
          <InputText
            id="newMail"
            value={newUserData.MailAddress || ""}
            onChange={(e) => handleNewInputChange(e, "MailAddress")}
            // onBlur={() => setMailAddressValid(!!newUserData.MailAddress)}
            // className={!mailAddressValid ? "p-invalid" : ""}
          />
        </div>
        <div className="p-field">
          <label htmlFor="newMobile">MobileNumber</label>
          <InputText
            id="newMobile"
            value={newUserData.MobileNumber || ""}
            onChange={(e) => handleNewInputChange(e, "MobileNumber")}
            // onBlur={() => setMobileNumberValid(!!newUserData.MobileNumber)}
            // className={!mobileNumberValid ? "p-invalid" : ""}
          />
        </div>
        <div className="p-field">
          <label htmlFor="mail">UserTypeId</label>
          <Dropdown
            id="UserTypeId"
            placeholder="Select a UserType"
            value={newUserData.UserTypeId || ""}
            onChange={(e) => {
              handleNewInputChange(e, "UserTypeId");
            }}
            onBlur={() => setUserTypeIdValid(!!newUserData.UserTypeId)}
            className={!userTypeIdValid ? "p-invalid" : ""}
            options={userTypeData.map((type) => ({
              label: type.UserType,
              value: type.UserTypeId,
            }))}
          />
        </div>
      </div>
    </>
  );
  const DeleteConfirmationPopup = (
    <>
      <div>
        <Button
          style={{ borderRadius: "5px", padding: "15px" }}
          label="Yes"
          icon="pi pi-check"
          onClick={confirmDelete}
          autoFocus
        />
        <Button
          style={{
            borderRadius: "5px",
            padding: "15px",
            backgroundColor: "lightslategray",
            color: "white",
          }}
          label="No"
          icon="pi pi-times"
          onClick={() => setDeleteConfirmation(false)}
          className="p-button-text"
        />
      </div>
    </>
  );
  const DeleteContent = (
    <>
      <div className="confirmation-content">
        Are you sure you want to delete this user?
      </div>
    </>
  );
  return (
    <div>
      <div
        id="plus_searchMaster"
        style={{ display: "flex", justifyContent: "flex-end" }}
      >
        <Button
          icon={
            <IoAddOutline
              style={{ color: "darkslategrey", fontSize: "50px" }}
            />
          }
          // icon="pi pi-plus"
          id="MasterPlusicon"
          onClick={openNew}
          className="p-button p-button-icon"
          title="Add"
        ></Button>
        <InputText
          id="MasterSearch"
          type="search"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="Search..."
        />
        <Button
          icon="pi pi-search"
          id="searchicon"
          style={{
            backgroundColor: "lightslategray",
            border: "lightslategray",
          }}
          className="p-button-primary"
          title="Search"
        />
      </div>
      <DataTable
        value={filteredUser}
        className="p-datatableAdmin"
        scrollable
        scrollHeight="440px"
        onSelectionChange={HandeleRowSelect}
        selectionMode="single"
        rowClassName={(rowData) =>
          selectedRowUser && selectedRowUser.UserID === rowData.UserID
            ? "selected-row"
            : ""
        }
      >
        <Column
          field="Username"
          header="Username"
          style={{ width: "20%" }}
          sortable
        />
        <Column field="Password" header="Password" sortable />
        <Column field="MailAddress" header="MailAddress" sortable />
        <Column field="MobileNumber" header="MobileNumber" sortable />
        <Column field="UserType" header="UserType" sortable />
        <Column header="Actions" body={actionTemplate} />
      </DataTable>
      <GlobalPopup
        visible={editDialogVisible}
        title="Edit User"
        onHide={() => setEditDialogVisible(false)}
        footerButtons={footerButtons}
        content={EditUsers}
      />
      <GlobalPopup
        visible={showDialog}
        title="New User"
        onHide={() => setShowDialog(false)}
        footerButtons={footerButtonsNewuser}
        content={NewUser}
      />
      <GlobalPopup
        title="Confirmation"
        visible={deleteConfirmation}
        onHide={() => setDeleteConfirmation(false)}
        footerButtons={DeleteConfirmationPopup}
        content={DeleteContent}
      />
    </div>
  );
}
